
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index81UBO_iKvOvaL9OEaODr5m1RAuv2Pw7zVONs__4QHl8Meta } from "/opt/buildhome/repo/app/pages/videos/index.vue?macro=true";
import { default as indexKWvJtVpdNPoKghLY7pfylgOgsqwPgNbf_7jCF_KsfqAMeta } from "/opt/buildhome/repo/app/pages/user/login/index.vue?macro=true";
import { default as sign_45upnZvADY55sA26N1DXGmvzrUKIWuIWXx_M6iKbzG4_uvAMeta } from "/opt/buildhome/repo/app/pages/developer/sign-up.vue?macro=true";
import { default as _91slug_937uCaaMqcuXC4t5mCgeONtHkhy6N_MPu9F_Oh_d8RIMwMeta } from "/opt/buildhome/repo/app/pages/videos/[id]/[slug].vue?macro=true";
import { default as index9gOnSPLUzxv7BgYQH9rOJTxheJXq6mkef6mv8nhqfEwMeta } from "/opt/buildhome/repo/app/pages/user/forgot-password/index.vue?macro=true";
export default [
  {
    name: "videos___en",
    path: "/en/videos",
    component: () => import("/opt/buildhome/repo/app/pages/videos/index.vue")
  },
  {
    name: "user-login___en",
    path: "/en/user/login",
    meta: indexKWvJtVpdNPoKghLY7pfylgOgsqwPgNbf_7jCF_KsfqAMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/user/login/index.vue")
  },
  {
    name: "developer-sign-up___en",
    path: "/en/developer/sign-up",
    meta: sign_45upnZvADY55sA26N1DXGmvzrUKIWuIWXx_M6iKbzG4_uvAMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/developer/sign-up.vue")
  },
  {
    name: "videos-id-slug___en",
    path: "/en/videos/:id()/:slug()",
    meta: {"middleware":["video-details"]},
    component: () => import("/opt/buildhome/repo/app/pages/videos/[id]/[slug].vue")
  },
  {
    name: "user-forgot-password___en",
    path: "/en/user/forgot-password",
    meta: index9gOnSPLUzxv7BgYQH9rOJTxheJXq6mkef6mv8nhqfEwMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/user/forgot-password/index.vue")
  }
]